(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["honho-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = root => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      const slides = [...root.querySelectorAll('[data-hh-banner-slide]')];
      const dots = [...root.querySelectorAll('[data-hh-banner-dot]')];
      if (slides.length < 2) return;
      let index = 0, timer, hovered = false, focused = false;
      let paused = root.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.Shopify?.designMode;
      const pause = root.querySelector('[data-hh-banner-pause]');
      const updatePause = () => { pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); pause.querySelector('[data-pause-icon]').textContent = paused ? '▶' : 'Ⅱ'; };
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { const active = i === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); if (!paused && !hovered && !focused && !document.hidden) timer = setInterval(() => show(index + 1), Number(root.dataset.delay)); };
      root.querySelector('[data-hh-banner-prev]').addEventListener('click', () => { show(index - 1); start(); });
      root.querySelector('[data-hh-banner-next]').addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
      pause.addEventListener('click', () => { paused = !paused; updatePause(); start(); });
      root.addEventListener('mouseenter', () => { hovered = true; stop(); });
      root.addEventListener('mouseleave', () => { hovered = false; start(); });
      root.addEventListener('focusin', () => { focused = true; stop(); });
      root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); start(); });
      const visibility = () => document.hidden ? stop() : start();
      document.addEventListener('visibilitychange', visibility);
      const section = root.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => { stop(); document.removeEventListener('visibilitychange', visibility); }, {once:true});
      section?.addEventListener('shopify:block:select', event => { const selected = event.target.closest('[data-hh-banner-slide]'); if (selected) { paused = true; updatePause(); stop(); show(slides.indexOf(selected)); } });
      updatePause(); start();
    };
    document.querySelectorAll('[data-hh-banner-slider]').forEach(bind);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hh-banner-slider]').forEach(bind));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honho-custom-editorial"] && !Shopify.designMode) return;
  try {
    
  class HonhoCustomStory extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (this.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 550, easing: 'cubic-bezier(.2,.65,.3,1)' });
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0.08 });
      this.querySelectorAll('[data-cv-reveal]').forEach((element) => this.observer.observe(element));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  if (!customElements.get('honho-custom-story')) customElements.define('honho-custom-story', HonhoCustomStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honho-first-order-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('honho-welcome')) {
    customElements.define('honho-welcome', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('[data-welcome-open]');
        this.key = this.dataset.key;
        const read = () => { try { return JSON.parse(localStorage.getItem(this.key) || '{}'); } catch { return {}; } };
        const save = (subscribed = false) => { try { localStorage.setItem(this.key, JSON.stringify({ until: Date.now() + Number(this.dataset.days) * 86400000, subscribed })); } catch {} };
        const open = () => {
          if (document.querySelector('dialog[open]') && !this.dialog.open) return;
          if (!this.dialog.open) this.dialog.showModal();
          this.tab.hidden = true;
        };
        this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.tab.addEventListener('click', open, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close(); } }, options);
        this.dialog.addEventListener('close', () => { const subscribed = !!this.querySelector('[data-welcome-success]') || read().subscribed; save(subscribed); this.tab.hidden = !!subscribed; }, options);
        const success = this.querySelector('[data-welcome-success]');
        if (success || this.querySelector('[data-welcome-errors]')) { if (success) save(true); open(); }
        else {
          const state = read();
          this.tab.hidden = !!state.subscribed;
          if (!state.subscribed && !state.until && this.dataset.editor !== 'true' && this.dataset.autoOpen === 'true' && !matchMedia('(max-width:749px)').matches) this.timer = setTimeout(open, Number(this.dataset.delay));
          else if (!state.subscribed && state.until < Date.now() && this.dataset.editor !== 'true' && this.dataset.autoOpen === 'true' && !matchMedia('(max-width:749px)').matches) this.timer = setTimeout(open, Number(this.dataset.delay));
        }
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', open, options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.dialog?.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
